import { ApiType } from "@gymflow/common";
import { useQuery } from "@tanstack/react-query";

import { smsQueryKeys } from "./smsQueryKeys";

export const useQuerySmsSettings = ({ api }: { api: ApiType }) =>
  useQuery({
    queryKey: smsQueryKeys.smsSettings(),
    queryFn: async () => (await api.smsApi.smsSettings()).data,
  });
